import type { BaseHttpRequest } from '@/api/generated-client/core/BaseHttpRequest';
import { ListRequestCursor } from '@/api/request/list-request-cursor';
import { PaginatedStopPhrasesResponseDto } from '@/api/models/paginated-stop-phrases-response.dto';
import { AddStopPhraseRequestDto } from '@/api/models/add-stop-phrase-request.dto';
import { StopPhraseResponseDto } from '@/api/models/stop-phrase-response.dto';
import { DeleteStopPhrasesParameters } from '@/api/models/delete-stop-phrases-parameters';
import { StopPhrasesBatchResponseDto } from '@/api/models/stop-phrases-batch-response.dto';
import { ListResponseDto } from '@/api/response/list-response.dto';
import { GetStopPhraseParameters } from '@/api/models/get-stop-phrase-parameters';
import { DeleteStopPhraseParameters } from '@/api/models/delete-stop-phrase-parameters';
import { GetStopPhrasesOffsetParameters } from '@/api/models/get-stop-phrases-offset-parameters';
import { BaseApi } from '@/api/base-api';

export class StopPhrasesApi extends BaseApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {
    super();
  }

  private controller = '/catalog/comments';

  public getStopPhrases(query: ListRequestCursor): Promise<PaginatedStopPhrasesResponseDto> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/game-comments/management/stop-phrases?${this.queryToQueryString(query)}`,
      {}
    );
  }

  public addStopPhrase(data: AddStopPhraseRequestDto): Promise<StopPhraseResponseDto> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[POST] /api/v1/game-comments/management/stop-phrases`,
      data,
    );
  }

  public deleteStopPhrases(query: DeleteStopPhrasesParameters): Promise<StopPhrasesBatchResponseDto> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[DELETE] /api/v1/game-comments/management/stop-phrases?${this.queryToQueryString(query)}`,
      {},
    );
  }

  public getStopPhrasesOffset(query: GetStopPhrasesOffsetParameters): Promise<ListResponseDto<StopPhraseResponseDto>> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/game-comments/management/stop-phrases/offset?${this.queryToQueryString(query)}`,
      {}
    );
  }

  public uploadStopPhrases(formData: { file: File; }): Promise<{ requestedCount: number; processedCount: number; }> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[UPLOAD] /api/v1/game-comments/management/stop-phrases/upload`,
      {},
      { formData }
    );
  }

  public getStopPhrase(params: GetStopPhraseParameters): Promise<StopPhraseResponseDto> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/game-comments/management/stop-phrases/${params.id}`,
      {}
    );
  }

  public deleteStopPhrase(params: DeleteStopPhraseParameters): Promise<void> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[DELETE] /api/v1/game-comments/management/stop-phrases/${params.id}`,
      {},
    );
  }
}
